import { render } from "./AppTabs.vue?vue&type=template&id=39cb0b93&ts=true"
import script from "./AppTabs.vue?vue&type=script&lang=tsx"
export * from "./AppTabs.vue?vue&type=script&lang=tsx"

import exportComponent from "/opt/esim/admin-src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__